(function () {
  'use strict';

  var INITIAL_TERM = 'Search our store';

  var TERMS = [
    'Ronin dock for Inovativ',
    'DJI RS3 gimbal mount',
    'AC front box',
    'Monitor hood FX6',
    'Film cart accessories',
    'Adicam storage trough',
    'Baby pin adaptor',
    'DJI RS4 dock',
    'Boom box tool case',
    'Inovativ wheel chock',
    'Tentacle sync mount',
    'Magliner accessories',
    'Cable hook',
    'SmallRig cart mount',
    'DIT storage solutions',
    'ProSSD cooling case',
    'Ronin RS2 holder',
    'Monitor hood Sony',
    'C-stand holder',
    'Superclamp mount',
    'Front box for AC',
    'Gimbal dock baby pin',
    'Adicam cart lip mount',
    'DJI Ronin RS3 Pro',
    'Film cart tool holder',
    'Custom design parts',
    'Sound Devices mount',
    'Inovativ Apollo dock',
    'Camera cart organiser',
    'Lens case insert'
  ];

  var DEFAULTS = {
    typeSpeed:        65,
    deleteSpeed:      35,
    pauseAfterType:   1800,
    pauseAfterDelete: 400,
    startDelay:       1200
  };

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  /* ── Per-input animation instance ─────────────────────── */

  function SearchAnimate(input) {
    this.input     = input;
    this.wrap      = null;
    this.overlay   = null;
    this.textNode  = null;
    this.cursor    = null;
    this.terms     = shuffle(TERMS);
    this.termIndex = -1; // increments to 0 after initial term is deleted
    this.current   = '';
    this.isPaused  = false;
    this.timer     = null;
  }

  SearchAnimate.prototype.init = function () {
    if (this.input.value.trim() !== '') return;

    this._buildWrap();
    this._buildOverlay();
    this._bindEvents();

    var self = this;
    // After startDelay, delete "Search our store" then begin product term cycle
    setTimeout(function () { self._deleteOut(); }, DEFAULTS.startDelay);
  };

  /* Wrap the input in a positioned flex span so the overlay
     can be positioned absolutely without breaking flex layout */
  SearchAnimate.prototype._buildWrap = function () {
    var wrap = document.createElement('span');
    wrap.className = 'sa-input-wrap';
    this.input.parentNode.insertBefore(wrap, this.input);
    wrap.appendChild(this.input);
    this.wrap = wrap;
  };

  SearchAnimate.prototype._buildOverlay = function () {
    var overlay = document.createElement('span');
    overlay.className = 'sa-placeholder';
    overlay.setAttribute('aria-hidden', 'true');

    // Clear native placeholder in JS — sidesteps any !important CSS conflicts
    this.input.placeholder = '';

    // Position left to match the input's own padding-left
    var cs = window.getComputedStyle(this.input);
    overlay.style.left     = cs.paddingLeft;
    overlay.style.fontSize = cs.fontSize;

    this.textNode = document.createTextNode('');
    overlay.appendChild(this.textNode);

    this.cursor = document.createElement('span');
    this.cursor.className = 'sa-cursor';
    overlay.appendChild(this.cursor);

    this.wrap.appendChild(overlay);
    this.overlay = overlay;

    // Pre-populate with "Search our store" so it's visible immediately
    this.current = INITIAL_TERM;
    this._render();

    this.input.classList.add('sa-animated-active');
  };

  SearchAnimate.prototype._bindEvents = function () {
    var self = this;

    this.input.addEventListener('focus', function () {
      self._pause();
      self._hide();
    });

    this.input.addEventListener('blur', function () {
      if (self.input.value.trim() === '') {
        self._resume();
      }
    });

    this.input.addEventListener('input', function () {
      if (self.input.value.trim() !== '') {
        self._hide();
        self.input.classList.remove('sa-animated-active');
      } else {
        self._show();
        self.input.classList.add('sa-animated-active');
      }
    });

    var form = this.input.closest('form');
    if (form) {
      form.addEventListener('submit', function () { self._destroy(); });
    }
  };

  SearchAnimate.prototype._startCycle = function () {
    if (this.isPaused) return;
    this._typeOut(this.terms[this.termIndex % this.terms.length]);
  };

  SearchAnimate.prototype._typeOut = function (term) {
    if (this.isPaused) return;
    var self = this;
    if (this.current.length < term.length) {
      this.current = term.substring(0, this.current.length + 1);
      this._render();
      this.timer = setTimeout(function () { self._typeOut(term); }, DEFAULTS.typeSpeed);
    } else {
      this.timer = setTimeout(function () { self._deleteOut(); }, DEFAULTS.pauseAfterType);
    }
  };

  SearchAnimate.prototype._deleteOut = function () {
    if (this.isPaused) return;
    var self = this;
    if (this.current.length > 0) {
      this.current = this.current.substring(0, this.current.length - 1);
      this._render();
      this.timer = setTimeout(function () { self._deleteOut(); }, DEFAULTS.deleteSpeed);
    } else {
      this.termIndex++;
      this.timer = setTimeout(function () { self._startCycle(); }, DEFAULTS.pauseAfterDelete);
    }
  };

  SearchAnimate.prototype._render = function () {
    if (this.textNode) this.textNode.textContent = this.current;
  };

  SearchAnimate.prototype._pause = function () {
    this.isPaused = true;
    clearTimeout(this.timer);
  };

  SearchAnimate.prototype._resume = function () {
    this.isPaused = false;
    this.current  = '';
    this._render();
    this._show();
    this.input.classList.add('sa-animated-active');
    var self = this;
    this.timer = setTimeout(function () { self._startCycle(); }, DEFAULTS.pauseAfterDelete);
  };

  SearchAnimate.prototype._show = function () {
    if (this.overlay) this.overlay.classList.remove('sa-hidden');
  };

  SearchAnimate.prototype._hide = function () {
    if (this.overlay) this.overlay.classList.add('sa-hidden');
  };

  SearchAnimate.prototype._destroy = function () {
    clearTimeout(this.timer);
    if (this.overlay) this.overlay.remove();
    this.input.classList.remove('sa-animated-active');
  };

  /* ── Bootstrap — one instance per search input ─────────── */

  function attach(input) {
    if (input.dataset.saInit) return;
    input.dataset.saInit = '1';
    new SearchAnimate(input).init();
  }

  function initAll() {
    document.querySelectorAll('input[name="q"], input[type="search"]')
      .forEach(attach);

    // Handle search inputs that appear in the DOM after page load
    // (e.g. mobile drawer rendered dynamically by theme JS)
    var observer = new MutationObserver(function () {
      document.querySelectorAll('input[name="q"], input[type="search"]')
        .forEach(attach);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
